<!-- The footer as one more box (owner 2026-10-12: modern, of a piece with the home): the home boxes' panel with the
     brand on top, five columns of links, and a thin line with the legal links and the version at its foot -->
<footer [class.footer-hide-shadow]="hideShadow" [class.footer-popup-padding]="popupPadding" class="footer">
  <div class="fx">

    <!-- the brand: logo, name and line; the social pages beside it -->
    <div class="fx-top">
      <a class="fx-brand" [routerLink]="URLS.root">
        <img [src]="BRAND.logo.main" [alt]="BRAND.name" class="fx-brand-logo" height="44" width="44"/>
        <span class="fx-brand-text">
          <span class="fx-brand-name">{{ BRAND.name }}</span>
          <span class="fx-brand-line">Coding is a creative craft. Themes, apps and tools to boost yours</span>
        </span>
      </a>
      <div class="fx-actions">
        <div class="fx-social">
          <app-ext-link *ngFor="let brandPage of BRAND_PAGES" [href]="brandPage.url"
                        [ariaLabel]="BRAND.name + ' on ' + brandPage.name">
            <app-icon [name]="brandPage.icon" [class]="brandPage.icon" fixedWidth aria-hidden="true" body></app-icon>
          </app-ext-link>
        </div>
      </div>
    </div>

    <div class="fx-columns">
      <!-- Apps & Plugins, by platform, as the tools: each platform's icons under its name, one platform under
           the other, the product's name on hover (owner 2026-10-20) -->
      <nav class="fx-col fx-col-apps" aria-label="Apps and plugins">
        <p class="fx-head">Apps &amp; Plugins</p>
        <div class="fx-app-groups">
          <div class="fx-app-group" *ngFor="let productLine of PLUGINS">
            <p class="fx-sub">{{ productLine.name }}</p>
            <div class="fx-app-icons">
              <a *ngFor="let product of productLine.products"
                 [attr.href]="productHref( product, productLine )"
                 (click)="redirectToProductUrl( product, productLine, $event )"
                 class="fx-theme fx-tool fx-app" [title]="product.name" [attr.aria-label]="product.name">
                <img [class.fx-app-icon-svg]="product.logo?.endsWith( '.svg' )" [src]="product.logo" alt="" width="32" height="32" loading="lazy" decoding="async"/>
              </a>
            </div>
          </div>
        </div>
      </nav>

      <!-- Themes as their round icons, as the themes box's dock -->
      <nav class="fx-col fx-col-themes" aria-label="Themes">
        <p class="fx-head">Themes</p>
        <div class="fx-themes">
          <a *ngFor="let theme of FOOTER_THEMES"
             [routerLink]="URLS.theme" [queryParams]="{ product: theme.product.key, category: theme.category }"
             class="fx-theme" [title]="theme.product.name" [attr.aria-label]="theme.product.name">
            <img [src]="theme.product.logo" alt="" width="32" height="32" loading="lazy" decoding="async"/>
          </a>
        </div>
        <a class="fx-all" [routerLink]="URLS.themes">All {{ themeCount }} Themes <svg class="link-chevron" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5.5l6.5 6.5L9 18.5"/></svg></a>
      </nav>

      <!-- the tools in the Tools page's groups, as their icons like the themes (owner 2026-10-12) -->
      <nav class="fx-col fx-col-tools" aria-label="Tools">
        <p class="fx-head">Tools</p>
        <div class="fx-tool-group" *ngFor="let group of TOOL_GROUPS" [class.fx-tool-group-wide]="group.limit">
          <p class="fx-sub">{{ group.name }}</p>
          <div class="fx-themes">
            <a *ngFor="let tool of group.tools | slice:0:( group.limit || group.tools.length )" [routerLink]="tool.url"
               class="fx-theme fx-tool" [title]="tool.name" [attr.aria-label]="tool.name">
              <img [src]="tool.logo" alt="" width="32" height="32" loading="lazy" decoding="async"/>
            </a>
          </div>
          <a *ngIf="group.limit" class="fx-all" [routerLink]="URLS.tools.tools">All {{ group.tools.length }} {{ group.name }} <svg class="link-chevron" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5.5l6.5 6.5L9 18.5"/></svg></a>
        </div>
      </nav>

      <nav class="fx-col fx-col-services" aria-label="Services">
        <p class="fx-head">Services</p>
        <ng-container *ngFor="let productLine of SERVICES">
          <a *ngFor="let product of productLine.products"
             [attr.href]="productHref( product, productLine )"
             (click)="redirectToProductUrl( product, productLine, $event )"
             class="fx-link">{{ product.name }}</a>
        </ng-container>
      </nav>

      <nav class="fx-col fx-col-company" aria-label="Company">
        <p class="fx-head">Company</p>
        <ng-container *ngFor="let page of COMPANY_LINKS">
          <a *ngIf="!page.isExternal" [routerLink]="page.url" class="fx-link">{{ page.name }}</a>
          <app-ext-link *ngIf="page.isExternal" [href]="page.url" [linkClass]="'fx-link'"><span body>{{ page.name }}</span></app-ext-link>
        </ng-container>
      </nav>
    </div>

    <!-- the foot: the legal pages and the version -->
    <div class="fx-bottom">
      <span class="fx-copy">&#169; 2026 {{ BRAND.name }}</span>
      <nav class="fx-legal" aria-label="Legal">
        <a *ngFor="let page of LEGAL_LINKS" [routerLink]="page.url">{{ page.name }}</a>
      </nav>
      <span class="fx-version">{{ 'ver. ' + appVersion + ( environment.identity !== 'production' ? '-' + environment.identity : '' ) }}</span>
    </div>
  </div>
</footer>
